export default class NavigationItemCollection
{
	constructor(collection)
	{
		this.setNavigationItems(collection);

		return this;
	}

	setNavigationItems(collection)
	{
		this.collection = collection;

		return this;
	}

	getNavigationItems()
	{
		return this.collection;
	}

	filterByAffix(affix)
	{
		return new NavigationItemCollection(Array.from(this.getNavigationItems().filter(navigationItem => {
			return navigationItem.getAffix() == affix;
		}).values()));
	}

	filterByCategory(category)
	{
		return new NavigationItemCollection(Array.from(this.getNavigationItems().filter(navigationItem => {
			return navigationItem.getCategory() == category;
		}).values()));
	}

	select()
	{
		this.getNavigationItems().map(navigationItem => {
			navigationItem.select();
		});

		return this;
	}

	unselect()
	{
		this.getNavigationItems().map(navigationItem => {
			navigationItem.unselect();
		});

		return this;
	}

	setFromQueryResponse(response)
	{
		this.getNavigationItems().map(navigationItem => {
			navigationItem.setFromQueryResponse(response);
		});
	}
}
